<vb-loading-spinner [block]="true" [iconClass]="'vb-icon vb-icon-camera-plus'" [msg]="'Media_Recording_Initializing' | translate" [msgDisplayBelowSpinner]="true" [size]="'large'">
</vb-loading-spinner>